/**
 * AddRoleButton — the dashed "+ Add <role>" affordance for an unfilled crew slot.
 *
 * Extracted from CrewSlotEditor so each file declares one component
 * (`react/no-multi-comp`); behaviour is unchanged.
 */
export function AddRoleButton({
  noun,
  emphasized,
  onClick,
}: {
  noun: string;
  emphasized: boolean;
  onClick: () => void;
}) {
  return (
    <button
      type="button"
      onClick={onClick}
      style={{
        marginTop: 2,
        padding: '7px 10px',
        borderRadius: 8,
        border: `1px dashed ${emphasized ? '#c0392b' : 'var(--nb-border-2)'}`,
        background: 'transparent',
        color: emphasized ? '#c0392b' : 'var(--nb-muted)',
        cursor: 'pointer',
        fontSize: 12.5,
        fontWeight: 600,
        textAlign: 'left',
      }}
    >
      + Add {noun}
    </button>
  );
}
